import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-950 flex items-center justify-center px-4">
      <div className="text-center">
        <div className="text-6xl md:text-8xl font-heading font-bold text-primary-500 mb-4">404</div>
        <h1 className="text-xl md:text-2xl font-heading font-semibold text-foreground-100 mb-3">页面未找到</h1>
        <p className="text-sm text-foreground-500 mb-8 max-w-md mx-auto">
          您访问的页面不存在或已被移除。请检查链接是否正确，或返回首页继续浏览精彩影视内容。
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm transition-colors whitespace-nowrap"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
      </div>
    </div>
  );
}